<template>
  <div class="w-full h-screen bg-gray-50">
    <Header></Header>
    <loading :active="isLoading"
             :can-cancel="true"
             :on-cancel="onCancel"
             color="#007bff"
             :is-full-page="fullPage"/>
    <div class="container mx-auto max-w-screen-xl px-4">
      <div class="w-full flex items-center justify-between mt-4 mb-2">
        <div class="flex">
          <h2
              class="mb-4 text-2xl font-semibold text-gray-700 dark:text-gray-200"
          >
            Usuário <span class="text-sm text-gray-400">{{ usuario.id ? 'Alterar' : 'Cadastrar'}}</span>
          </h2>
        </div>

        <div class="flex">
          <router-link
              to="/usuario"
              class="mb-4 text-lg inline-block border hover:bg-gray-100 border-gray-500 rounded py-1 px-3 outline-none focus:outline-none text-gray-800 mr-2">
            <span class="mx-1">Voltar</span>
          </router-link>
        </div>
      </div>

      <Alert :show="alert.show" :type="alert.type" @close="onClose"> {{ alert.texto }} </Alert>

      <form class="mb-2 px-3" @submit.prevent="onSubmit">
        <div class="flex flex-wrap -mx-3 mb-4">
          <div class="w-full md:w-6/12">
            <label class="text-gray-700 required" for="email">E-mail</label>
            <input
                required
                class="form-control"
                id="email"
                v-model="usuario.email"
                type="email"
                placeholder="E-mail"
            />
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-2">
          <h5>Perfis</h5>
          <table class="table-auto min-w-full divide-y divide-gray-200 text-md">
            <thead>
            <tr>
              <th class="border p-2">Selecionar</th>
              <th class="border p-2">Perfil</th>
              <th class="border p-2">Descrição</th>
            </tr>
            </thead>
            <tbody>
              <template v-for="(grupo, modulo) in perfis" >
                <tr>
                  <td colspan="3" class="border p-2">Módulo: {{ modulo }}</td>
                </tr>
                <tr v-for="(item, index) in grupo" :key="item.id"
                    :class="(index % 2) === 0 ? 'bg-gray-100' : ''">
                  <td class="border p-2 text-center">
                    <input type="checkbox"  :name="'segment[' + index + ']'" class="cursor-pointer"
                           :value="item.selecionado" v-model="item.selecionado"
                           @change="onChangeCheckbox(modulo, item.id)">
                  </td>
                  <td class="border p-2">{{ item.perfil }}</td>
                  <td class="border p-2">{{ item.descricao }}</td>
                </tr>

              </template>
            </tbody>
          </table>
        </div>
        <div class="flex flex-wrap -mx-3 mt-4 space-x-2">
          <ButtonVoltar link="/usuario">Voltar</ButtonVoltar>

          <ButtonSubmit>Confirmar</ButtonSubmit>

        </div>
      </form>

    </div>


  </div>
</template>

<script>
import axios from "@/axios-auth";
import Header from "@/components/layout/Header.vue";
import Icone from "@/components/base/Icone.vue";
import loadingMixin from "@/mixins/loadingMixin";
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import utilMixin from "@/mixins/utilMixin";
import Alert from "@/components/base/Alert.vue";
import ButtonSubmit from "@/components/base/ButtonSubmit.vue";
import ButtonVoltar from "@/components/base/ButtonVoltar.vue";


export default {
  props: ["id"],
  mixins: [loadingMixin, utilMixin],
  components: {ButtonVoltar, ButtonSubmit, Alert, Icone, Header, Loading},
  data: () => ({
    showDialog: false,
    showModal: false,
    email: null,
    usuario: {id: null, email: null, perfis: [] },
    perfis: [],
  }),
  created() {
    this.carregarPerfis();
  },
  methods: {
    onChangeCheckbox(modulo, perfilId) {
      this.perfis[modulo].forEach((element) => {
        if (element.id !== perfilId) {
          element.selecionado = false;
        }
      })

    },
    async carregarPerfis() {
      try {
        this.isLoading = true;

        const chamadas = [
          axios.get('perfil/lista')
        ]

        if (this.id) {
          chamadas.push(axios.get(`usuario/${this.id}`))
        }

        const respostas = await Promise.all(chamadas);

        if (this.id) {
          this.usuario = respostas[1].data;
        }

        const perfis = respostas[0].data;

        const idsAssociados = new Set(this.usuario.perfis.map(perfil => perfil.id));
        const perfisSelecionados = perfis.map(perfil => ({
          ...perfil,
          selecionado: idsAssociados.has(perfil.id)
        }));

        this.perfis = perfisSelecionados.reduce((acc, perfil) => {
          const key = perfil.modulo;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(perfil);
          return acc;
        }, {});


      } catch (error) {
        this.setAlert("danger", error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmit() {
      const payload = Object.assign({}, this.usuario);
      const perfisSelecionados = [];
      Object.values(this.perfis).forEach( modulo => {
        const perfil = modulo.find(p => p.selecionado === true);
        if (perfil) {
          perfisSelecionados.push(perfil);
        }
      })

      payload.perfis = perfisSelecionados;

      try {
        this.isLoading = true;
        let msg = "Usuário cadastrado com sucesso";
        if (this.id) {
          await axios.put(`usuario/${this.id}`, payload)
          msg = "Usuário atualizado com sucesso"
        } else {
          await axios.post(`usuario`, payload);
        }

        this.setAlert("success", msg);
      } catch (err) {
        let msg = err.response.data.message;
        if (err.response.data?.errors && Array.isArray(err.response.data?.errors)) {
          msg = err.response.data?.errors.map(e => e.message).join(", ");
        }

        this.setAlert("danger", msg);
      } finally {
        this.isLoading = false;
      }

    },
    onClose() {
      this.alert.show = false;
    }
  }
}


</script>
